import {connect} from 'react-redux';
import {
  networkStatusSelector,
  newContentAvailableSelector,
} from '../../../reducers';
import OfflineStatus from './component';

const mapStateToProps = (state) => {
  return {
    status: networkStatusSelector(state),
    newContentAvailable: newContentAvailableSelector(state),
  };
};

export default connect(mapStateToProps)(OfflineStatus);



// WEBPACK FOOTER //
// ./src/component/organisms/OfflineStatus/index.js